"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = function Edit(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("g", {
    opacity: "0.5"
  }, _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 6H12H8V18H12H16V10V6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 18.5H8C7.86739 18.5 7.74021 18.4473 7.64645 18.3536C7.55268 18.2598 7.5 18.1326 7.5 18V6C7.5 5.86739 7.55268 5.74021 7.64645 5.64645C7.74021 5.55268 7.86739 5.5 8 5.5H16C16.1326 5.5 16.2598 5.55268 16.3536 5.64645C16.4473 5.74021 16.5 5.86739 16.5 6V18C16.5 18.1326 16.4473 18.2598 16.3536 18.3536C16.2598 18.4473 16.1326 18.5 16 18.5ZM8.5 17.5H15.5V6.5H8.5V17.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("path", {
    d: "M12 16.5001C11.9011 16.5001 11.8044 16.4708 11.7222 16.4158C11.64 16.3609 11.5759 16.2828 11.5381 16.1915C11.5002 16.1001 11.4903 15.9996 11.5096 15.9026C11.5289 15.8056 11.5765 15.7165 11.6464 15.6466L17.6464 9.64656C17.7404 9.5536 17.8673 9.50161 17.9995 9.50195C18.1316 9.5023 18.2583 9.55495 18.3517 9.64841C18.4452 9.74186 18.4978 9.86851 18.4982 10.0007C18.4985 10.1328 18.4465 10.2597 18.3535 10.3537L12.3535 16.3537C12.3072 16.4002 12.2521 16.437 12.1914 16.4622C12.1307 16.4873 12.0657 16.5002 12 16.5001Z",
    fill: props.foregroundColor
  }));
};

Edit.defaultProps = {
  altText: "Edit",
  backgroundColor: "#212121",
  foregroundColor: "#FFFFFF"
};
Edit.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Edit;
exports.default = _default;